'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./toolbar.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Toolbar(_ref) {
  var align = _ref.align,
      background = _ref.background,
      density = _ref.density,
      justify = _ref.justify,
      className = _ref.className,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['align', 'background', 'density', 'justify', 'className', 'style']);

  var classes = (0, _classnames2.default)('toolbar', 'toolbar--background-' + background, 'toolbar--density-' + density, align && 'toolbar--align-' + align, justify && 'toolbar--justify-' + justify, className);

  if (props.padding) {
    console.warn('Toolbar component: The padding property is deprecated, please use density');
  }

  return _react2.default.createElement(
    'div',
    { className: classes, style: style },
    props.children
  );
}

Toolbar.propTypes = {
  align: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'baseline', 'stretch']),
  background: _propTypes2.default.oneOf(['transparent', 'light', 'dark']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  density: _propTypes2.default.oneOf(['none', 'compact', 'cozy', 'comfortable']),
  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  padding: _propTypes2.default.string,
  style: _propTypes2.default.object
};

Toolbar.defaultProps = {
  align: 'baseline',
  background: 'light',
  density: 'cozy'
};

exports.default = Toolbar;